/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect } from "react";
import { Select, Button, Form, Row, Col, DatePicker, Input } from "antd";
import locale from "antd/es/date-picker/locale/es_ES";
import "dayjs/locale/es";
import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";

import { formatDate, removeDuplicates } from "../../utils/utils";
import { useSearchParams } from "react-router-dom";
import { useFetchOrdersBy, useFilters } from "../../app/orders/mutations";
import useFetchMaster from "../../app/maestro/mutations";
dayjs.extend(calendar);
const { RangePicker } = DatePicker;

export function HeaderForm({ form, onSubmit, disabled, ordersIds, documentsIds, statuses, entregaIds, fechasEntregas, isLoading }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isDisabled, setIsDisabled] = useState(disabled);
  const [_statuses, setStatuses] = useState(statuses);
  const [datePickerDisabled, setDatePickerDisabled] = useState(false);

  const [points, setPoints] = useState([]);

  const queryParams = Object.fromEntries([...searchParams]);
  let { isLoading: isLoadingMaster, data: master } = useFetchMaster();

  const { addFilter } = useFilters();

  useEffect(() => {
    setIsDisabled(disabled);
    setStatuses(statuses);
  }, [disabled, statuses]);

  // Update datePickerDisabled when form initializes or changes
  useEffect(() => {
    const orderValue = form.getFieldValue('numeroOrdenBusqueda');
    setDatePickerDisabled(!!(orderValue && orderValue.trim()));
  }, [form]);

  const onFinish = (values) => {
    const { fechaInicioPedido: f1, numeroOrdenBusqueda } = values;

    let queryParamsToSubmit = {};
    let searchParamsToSet = {};

    if (numeroOrdenBusqueda && numeroOrdenBusqueda.trim() !== "") {
      // Prioritize search by order number
      queryParamsToSubmit = { id_orden: numeroOrdenBusqueda.trim() };
      searchParamsToSet = { id_orden: numeroOrdenBusqueda.trim() };
      form.setFieldsValue({ fechaInicioPedido: null }); // Clear date picker
      // Also clear order number if user switches to date search
    } else if (f1 && f1.length === 2) {
      // Proceed with date range search
      const [start, end] = f1;
      if (end.diff(start, 'days', true) > 10) {
        form.setFields([{
          name: 'fechaInicioPedido',
          errors: ['El rango de fechas no puede ser mayor a un 10 dias'],
        }]);
        return;
      }
      queryParamsToSubmit = {
        fechaInicioPedido: formatDate(f1[0].$d),
        fechaFinPedido: formatDate(f1[1].$d),
      };
      searchParamsToSet = { ...queryParamsToSubmit };
      form.setFieldsValue({ numeroOrdenBusqueda: null }); // Clear order number input
    } else {
      // Handle case where neither is provided, or date range is incomplete
      // This might need specific error handling or a default behavior
      if (!numeroOrdenBusqueda || numeroOrdenBusqueda.trim() === "") {
         form.setFields([{
          name: 'fechaInicioPedido',
          errors: ['Debe ingresar un rango de fechas o un número de orden.'],
        }]);
      }
       if ((!f1 || f1.length !== 2) && (!numeroOrdenBusqueda || numeroOrdenBusqueda.trim() === "")){
         form.setFields([{
          name: 'fechaInicioPedido',
          errors: ['Requerido'],
        }]);
       }
      return;
    }

    setSearchParams(searchParamsToSet);
    onSubmit(queryParamsToSubmit);

    // form.setFieldValue("cedula", null); // These seem to be for sub-filters, keep as is for now
    // form.setFieldValue("fechaFinPromesa", null);
    // form.setFieldValue("fechaInicioPromesa", null);
  };

  const handleClientNameChange = (event) => {
    const client = event.split("-");
    addFilter({ label: "Cliente", prop: "nombreCliente", value: client[1] });
    useFetchOrdersBy();

    const points = master.clientes.filter((c) => c.id_cliente === client[0]);
    setPoints(points);
    form.setFieldValue("nombreCliente", null);
  };

  const handlePointChange = (event) => {
    addFilter({ label: "Punto de venta", prop: "puntoVenta", value: event });
    useFetchOrdersBy();
    form.setFieldValue("puntoVenta", null);
  };

  const handleDocumentChange = (event) => {
    const searchTerm = event;
    if (searchTerm) {
      addFilter({
        label: "Cedula",
        prop: "cedula",
        value: searchTerm,
      });
      useFetchOrdersBy();
    }
  };

  const handleEntrega = (event) => {
    const searchTerm = event;
    if (searchTerm) {
      addFilter({
        label: "Entrega",
        prop: "entrega",
        value: searchTerm,
      });
      useFetchOrdersBy();
    }
    form.setFieldValue("entrega", null);
  };

  const handleFechaEntrega = (event) => {
    const searchTerm = event;
    if (searchTerm) {
      addFilter({
        label: "F. Entrega",
        prop: "fechaEntrega",
        value: searchTerm,
      });
      useFetchOrdersBy();
    }
    form.setFieldValue("fechaEntrega", null);
  };

  const handleOrderChange = (event) => {
    const searchTerm = event;
    if (searchTerm && searchTerm.length > 0) {
      addFilter({ label: "Orden", prop: "ordenCompra", value: searchTerm });
      useFetchOrdersBy();
    }
    form.setFieldValue("ordenCompra", null);
  };

  const handleInitPromiseDate = (event) => {
    if (event) {
      const fecha = formatDate(event[1].$d);
      addFilter({
        label: "F. Inicial Promesa",
        prop: "fechaPromesa",
        value: fecha,
      });
      useFetchOrdersBy();
      form.setFieldValue("fechaFinPromesa", dayjs(formatDate(new Date())));
    }
  };
  
  const handleClear = () => {
    form.setFieldValue("nombreCliente", undefined);
  };

  const handleStatusChange = (event) => {
    addFilter({ label: "Estado", prop: "estado", value: event });
    useFetchOrdersBy();
    form.setFieldValue("estado", null);
  };

  /*Control 30 dias en seleccion de fecha*/
  const [range, setRange] = useState([null, null]);

  const handleRangeChange = (dates) => {
    if (!dates || dates.length === 0) {
      setRange([null, null]);
      form.setFieldsValue({ fechaInicioPedido: null });
      form.validateFields(['numeroOrdenBusqueda']);
    } else {
      const [start, end] = dates;
      if (start && end && end.diff(start, 'days') > 10) {
        const newEnd = start.clone().add(10, 'days');
        setRange([start, newEnd]);
        form.setFieldsValue({ fechaInicioPedido: [start, newEnd] });
        form.validateFields(['numeroOrdenBusqueda']);
      } else {
        setRange(dates);
        form.setFieldsValue({ fechaInicioPedido: dates });
        form.validateFields(['numeroOrdenBusqueda']);
      }
    }
  };

  const disabledDate = (current) => {
    if (!range[0] && !range[1]) {
      return false;
    }
    const tooLate = range[0] && current > dayjs(range[0]).add(10, 'day');
    const tooEarly = range[1] && current < dayjs(range[1]).subtract(10, 'day');
    return tooLate || tooEarly;
  };
  /*Control 30 dias en seleccion de fecha*/  

  return (
    <div className="orders-form">
      <Form
        form={form}
        autoComplete="off"
        name="ordersForm"
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          fechaInicioPedido: queryParams.fechaInicioPedido && queryParams.fechaFinPedido ? [dayjs(
            queryParams.fechaInicioPedido, // Already formatted from URL
            "YYYY-MM-DD"
          ),dayjs(
            queryParams.fechaFinPedido, // Already formatted from URL
            "YYYY-MM-DD"
          )] : [dayjs().subtract(2, "day"), dayjs().add(2, "day")],
          numeroOrdenBusqueda: queryParams.id_orden || null,
        }}
      >
        <Row>
          <Col span={24} style={{ textAlign: 'center', marginBottom: 8 }}>
            <b>Buscar por rango de fechas <span style={{ color: '#888' }}>o</span> por identificador de orden</b>
            <div style={{ fontSize: 12, color: '#888' }}>
              Solo uno de los dos campos debe ser completado para realizar la búsqueda. Si ambos tienen valor, se prioriza el identificador de orden.
            </div>
          </Col>
        </Row>
        <Row className="form--first-row" style={{ marginBottom: 15 }}>
          <Col className="gutter-row">
            <Form.Item
              name="fechaInicioPedido"
              label="Fecha Pedido"
              validateTrigger={['onChange', 'onBlur']}
              rules={[{ 
                validator: (_, value) => {
                  const numeroOrden = (form.getFieldValue('numeroOrdenBusqueda') || '').trim();
                  if ((!value || value.length !== 2) && !numeroOrden) {
                    return Promise.reject(new Error('Requerido si Id de Orden está vacío'));
                  }
                  return Promise.resolve();
                }
              }]}
            >
              <RangePicker
                locale={locale}
                size="medium"
                onCalendarChange={handleRangeChange}
                disabledDate={disabledDate}
                disabled={datePickerDisabled}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name="numeroOrdenBusqueda"
              label="Identificador de Orden"
              validateTrigger={['onChange', 'onBlur']}
              rules={[{
                validator: (_, value) => {
                  const fechaPedido = form.getFieldValue('fechaInicioPedido');
                  const orderValue = (value || '').trim();
                  if (!orderValue && (!fechaPedido || fechaPedido.length !== 2)) {
                    return Promise.reject(new Error('Requerido si Fecha Pedido está vacío'));
                  }
                  return Promise.resolve();
                }
              }]}
            >
              <Input 
                placeholder="Ingrese Id Orden" 
                size="medium" 
                allowClear
                onChange={e => {
                  const value = e.target.value;
                  form.setFieldsValue({ numeroOrdenBusqueda: value });
                  // Set date picker disabled state based on input value
                  setDatePickerDisabled(!!(value && value.trim()));
                  if (value && value.trim() !== '') {
                    // Clear validation errors on fechaInicioPedido when typing in order ID
                    form.setFields([{
                      name: 'fechaInicioPedido',
                      errors: []
                    }]);
                  } else {
                    form.validateFields(['fechaInicioPedido']);
                  }
                }}
                onBlur={() => {
                  const value = form.getFieldValue('numeroOrdenBusqueda');
                  setDatePickerDisabled(!!(value && value.trim()));
                  if (!value || value.trim() === '') {
                    form.validateFields(['fechaInicioPedido']);
                  }
                }}
                disabled={!!(form.getFieldValue('fechaInicioPedido') && form.getFieldValue('fechaInicioPedido').length === 2) && !(form.getFieldValue('numeroOrdenBusqueda') || '').trim()}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item>
              <Button
                htmlType="submit"
                type="default"
                className="btn-green"
                id="btn-order"
                size="medium"
                disabled={isLoading}
                loading={isLoading}
              >
                Consultar
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row>
        <Col className="gutter-row">
            <Form.Item
              name="ordenCompra"
              rules={[{ required: false, message: "requerido" }]}
              label="Pedido / Orden"
            >
              <Select
                showSearch
                size="medium"
                placeholder="Seleccione"
                disabled={isDisabled}
                onClear={handleClear}
                options={ordersIds.map((document) => {
                  return {
                    value: document,
                    label: document,
                  };
                })}
                onChange={handleOrderChange}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name="fechaInicioPromesa"
              rules={[{ required: false, message: "Requerido" }]}
              label="Fecha Promesa"
            >
              <RangePicker
                locale={locale}
                size="medium"
                disabled={isDisabled}
                onChange={handleInitPromiseDate}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name="fechaEntrega"
              rules={[{ required: false, message: "requerido" }]}
              label="Fecha Entrega"
            >
              <Select
                showSearch
                size="medium"
                placeholder="Seleccione"
                disabled={isDisabled}
                onClear={handleClear}
                options={fechasEntregas.map((entrega) => {
                  return {
                    value: entrega,
                    label: entrega,
                  };
                })}
                onChange={handleFechaEntrega}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name="entrega"
              rules={[{ required: false, message: "requerido" }]}
              label="# Entrega"
            >
              <Select
                showSearch
                size="medium"
                placeholder="Seleccione"
                disabled={isDisabled}
                onClear={handleClear}
                options={entregaIds.map((entrega) => {
                  return {
                    value: entrega,
                    label: entrega,
                  };
                })}
                onChange={handleEntrega}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            {!isLoadingMaster && master && (
              <Form.Item
                name="nombreCliente"
                rules={[{ required: false, message: "requerido" }]}
                label="Cliente"
              >
                <Select
                  showSearch
                  size="medium"
                  placeholder="Seleccione"
                  disabled={isDisabled}
                  allowClear={true}
                  onClear={handleClear}
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={[
                    ...removeDuplicates(
                      master?.clientes.map(
                        (e) => `${e.id_cliente}-${e.nombre_cliente}`
                      )
                    ).map((p, index) => {
                      return {
                        value: `${p}`,
                        label: `${p.toUpperCase().split("-")[1]}`,
                      };
                    }),
                  ]}
                  onChange={handleClientNameChange}
                />
              </Form.Item>
            )}
          </Col>
          <Col className="gutter-row">
            {!isLoadingMaster && master && (
              <Form.Item
                name="puntoVenta"
                rules={[{ required: false, message: "requerido" }]}
                label="Punto de venta"
              >
                <Select
                  showSearch
                  size="medium"
                  placeholder="Seleccione"
                  disabled={isDisabled}
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={[
                    ...points.map((p) => {
                      return {
                        value: `${p.punto_venta}-${p.nombre_punto_venta}`,
                        label: `${p.punto_venta}-${p.nombre_punto_venta}`,
                      };
                    }),
                  ]}
                  onChange={handlePointChange}
                />
              </Form.Item>
            )}
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name="cedula"
              rules={[{ required: false, message: "requerido" }]}
              label="Cedula"
            >
              <Select
                showSearch
                size="medium"
                placeholder="Seleccione"
                disabled={isDisabled}
                onClear={handleClear}
                options={documentsIds.map((document) => {
                  return {
                    value: document,
                    label: document,
                  };
                })}
                onChange={handleDocumentChange}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name="estado"
              rules={[{ required: false, message: "requerido" }]}
              label="Estado"
            >
              <Select
                showSearch
                size="medium"
                placeholder="Seleccione"
                disabled={isDisabled}
                onClear={handleClear}
                options={_statuses}
                onChange={handleStatusChange}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
